import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74ba3b88"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("管理员")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("管理类")
const _hoisted_3 = { class: "box-card" }

import { verification } from "@@/../shared-common/src/util/verification";
import { setFormRequired } from "@ldos/shared-pc/src/util/miscUtils";
import _ from "lodash";
import { reactive, getCurrentInstance, ref, computed } from "vue";
import { IStaffInfo, IStoreRole } from "../interface";
import stubs from "@/init";

export default /*#__PURE__*/_defineComponent({
  props: {
  curUser: {
    type: Object,
  },
  terminal: {
    type: String,
    default: "",
  },
},
  setup(__props, { expose }) {

const props = __props

const { proxy } = getCurrentInstance() as any;
const storeRoleRef = ref<any>(null);



// 校验门店/角色
const validateStoreAndRole = (rule: any, value: any, callback: any) => {
  if (!state.form.store && !state.form.role) {
    callback(new Error("请选择门店/角色"));
  } else if (!state.form.store) {
    callback(new Error("请选择门店"));
  } else if (!state.form.role) {
    callback(new Error("请选择角色"));
  } else {
    callback();
  }
};

const validateWUserId = async (rule: any, value: any, callback: any) => {
  if (!(value && value?.length > 0)) {
    callback();
    return;
  }
  const corpId = proxy?.$wecom.obtainDefaultImktCorp()?.corpId;
  const suiteId = proxy?.$wecom.obtainImktSuite()?.suiteId;
  if (props.terminal === "ops") {
    var api = "/ops/userTenant/checkWechatUser";
  } else {
    var api = "/mgr/userTenant/checkWechatUser";
  }
  const [data] = await stubs.api.post(api, {
    wUserId: value,
    userId: state.form.id || "",
    corpId: corpId,
    suiteId: suiteId,
  });
  if (!data.status) {
    callback(new Error(data.content));
    return;
  }
  callback();
};

const validateMobile = (rule: any, value: any, callback: any) => {
  if (!state.form.mobile) {
    callback(new Error("请输入员工手机号"));
  } else if (!verification.telephone.test(state.form.mobile)) {
    callback(new Error("手机号格式不正确"));
  } else {
    callback();
  }
};
const state: any = reactive({
  disableWUserIdEdit: false,
  dialog: false,
  title: "",
  mode: "add",
  form: {},
  ruleForm: {
    tenantId: [{ required: true, message: "请选择租户", trigger: "blur" }],
    username: [{ required: true, message: "请输入员工账号", trigger: "blur" }],
    displayName: [{ required: true, message: "请输入员工姓名", trigger: "blur" }],
    mobile: [
      {
        required: true,
        validator: validateMobile,
        trigger: "blur",
      },
    ],
    post: [{ required: true, message: "请输入员工岗位名称", trigger: "blur" }],
    store: [{ required: true, validator: validateStoreAndRole, trigger: "change" }],
    disabled: [{ required: true, message: "请选择员工状态", trigger: "change" }],
    wUserId: [
      {
        validator: validateWUserId,
        trigger: "blur",
      },
    ],
  },
  storeStateList: [
    {
      value: false,
      label: "启用",
    },
    {
      value: true,
      label: "停用",
    },
  ],
});

const active = (res: IStaffInfo) => {
  state.disableWUserIdEdit = res.form?.id?.length > 0 && res.form?.wUserId?.length > 0;
  state.title = res.title;
  state.mode = res.mode;
  state.storeList = res.storeList;
  if (!res.form.storeRoleList.length) {
    res.form.storeRoleList.push({
      roleId: "",
      shopId: "",
    });
  }
  state.form = { ...res.form };

  state.dialog = true;

  state.ruleForm = setFormRequired(state.ruleForm, state.mode === "detail" ? true : false);

  const storeRoleObj = {
    storeList: state.storeList,
    storeRoleList: state.form.storeRoleList,
    id: state.form?.id,
  };
  state.tenantAll = res.tenantAll;
  if (state.mode === "edit") {
    state.tenantAll.forEach((el1) => {
      el1?.children?.forEach((el2) => {
        console.error(res.form.storeRoleList[0].shopId, el1.value);
        if (res.form.storeRoleList[0].shopId === "__") {
          state.form.tenantId = el1.value;
          return;
        }
        if (res.form.storeRoleList[0].shopId === el2.value) {
          state.form.tenantId = el1.value;
        }
      });
    });
  }

  setTimeout(() => {
    storeRoleRef.value.active(storeRoleObj);
  }, 50);
};
const shopAndRoleList = computed(() => {
  return [{
    value: "",
    label: "全部",
  }].concat(proxy.pocket(`userRole`).filter((item: any) => item.extra?.type === state.form.postType))
});
const onChangeTenant = () => {
  getAllShopUserByTenant(state.form.tenantId);
};

// 根据tenantId 获取 所有 门店 角色
const getAllShopUserByTenant = async (tenantId: string) => {
  const [res] = await proxy.$api.get("/ops/role/roleBytenantId?tenantId=" + tenantId);
  const storeList = _.uniqBy(res, "shopId").map((el) => ({
    label: el.shopName,
    value: el.shopId,
    children: [],
  }));
  res.forEach((el: any) => {
    let index = storeList.findIndex((el2: any) => {
      return el2.value === el.shopId;
    });
    storeList[index].children.push({
      label: el.name,
      value: el.roleId,
    });
  });
  state.storeList = storeList;
};
const storeRoleSelectChange = (res: IStoreRole[]) => {
  state.form.storeRoleList = [];
  let storeStr: any[] = [];
  let roleStr: any[] = [];
  if (res.length) {
    res.forEach((x: IStoreRole) => {
      storeStr.push(x.shopId);
      roleStr.push(x.roleId);
    });
    state.form.store = storeStr.length ? _.uniqWith(storeStr, _.isEqual).join(",") : "";
    state.form.role = roleStr.length ? _.uniqWith(roleStr, _.isEqual).join(",") : "";
    state.form.shopRoles = res.filter((x: IStoreRole) => x.shopId !== "" && x.roleId !== "");
  }
};

const bigRegionList = computed(() => {
  state.form.region = "";
  return [{ label: "全部", value: "" }].concat(proxy.pocket("regions").filter((item: any) => item.extra?.parent === state.form.saleModel || !state.form.saleModel));
})

const villageList = computed(() => {
  state.form.village = "";
  return [{ label: "全部", value: "" }].concat(proxy.pocket("villages").filter((item: any) => item.extra?.parent === state.form.region || (!state.form.region && bigRegionList.value.map(item => item.value).includes(item.extra?.parent))));
})

const shopList = computed(() => {
  state.form.shop = "";
  return [{ label: "全部", value: "" }].concat(proxy.pocket("shopDepartments").filter((item: any) => item.extra?.parent === state.form.village || (!state.form.village && villageList.value.map(item => item.value).includes(item.extra?.parent))));
})

const confimForm = async (res: any) => {
  // 组装数据 清理多余的字段
  let requestObj = {
    id: res.id ? res.id : "",
    username: res.username,
    displayName: res.displayName,
    mobile: res.mobile,
    post: res.post,
    shopRoles: res.shopRoles || [],
    wUserId: res.wUserId,
    disabled: res.disabled,
    version: res.version,
    total: res.total,
    pageSize: res.pageSize,
    current: 1,
    tenantId: res.tenantId,
    postType: res.postType,
    shop: res.shop,
    saleModel: res.saleModel,
    region: res.region,
    village: res.village,
    roleId: res.roleId,
    weChatMobile: res.weChatMobile,
    state: res.state,
  };
  // 编辑需要增加版本号
  if (state.mode === "edit") {
    requestObj.version = res.version;
    requestObj.current = res.current;
  }
  if (props.terminal === "ops") {
    var api = "/ops/userTenant/save";
    requestObj.tenantId = state.form.tenantId;
  } else if (state.mode === "open") {
    var api = "/mgr/userTenant/openStaff";
    requestObj.state = "EFFECTIVE";
  } else {
    var api = "/mgr/userTenant/save";
  }
  const [data] = await proxy.$api.post(api, requestObj);
  proxy.$Message({
    type: "success",
    message: "操作成功",
  });
  state.dialog = false;
  proxy.$emit("optionSuccess", data);
};
expose({
  active,
});

return (_ctx: any,_cache: any) => {
  const _component_MasFormGroupTitle = _resolveComponent("MasFormGroupTitle")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_mas_modal = _resolveComponent("mas-modal")!

  return (_openBlock(), _createBlock(_component_mas_modal, {
    visible: _unref(state).dialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).dialog) = $event)),
    customFooterBtns: "",
    closeIcon: "",
    width: "750px",
    title: _unref(state).title
  }, {
    content: _withCtx(() => [
      _createVNode(_component_mas_form_main, {
        form: _unref(state).form,
        ruleForm: _unref(state).ruleForm,
        inline: true,
        disabled: _unref(state).mode === 'detail' ? true : false,
        defaultFormFooter: _unref(state).mode === 'detail' ? false : true,
        defaultFormFooterButton: ['confirm', 'cancel'],
        onConfim: confimForm,
        labelWidth: "100px",
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).dialog = false))
      }, {
        content: _withCtx((slotProps) => [
          _createVNode(_component_MasFormGroupTitle, { title: "员工信息" }),
          (_ctx.$props.terminal === 'ops')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "租户",
                prop: "tenantId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: slotProps.content.tenantId,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.content.tenantId) = $event),
                    placeholder: "请选择租户",
                    onChange: onChangeTenant
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).tenantAll, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "姓名",
            prop: "displayName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入员工姓名",
                modelValue: slotProps.content.displayName,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.displayName) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "账号",
            prop: "username"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入员工账号",
                disabled: _unref(state).mode === 'edit' ? true : false,
                modelValue: slotProps.content.username,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.username) = $event)
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "手机号",
            prop: "mobile"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                maxlength: "11",
                placeholder: "请输入员工手机号",
                modelValue: slotProps.content.mobile,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.mobile) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "企微账号",
            prop: "weChatMobile"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入员工企微账号",
                modelValue: slotProps.content.weChatMobile,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.weChatMobile) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "岗位",
            prop: "post"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入员工岗位",
                modelValue: slotProps.content.post,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.post) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "岗位类型",
            prop: "postType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: slotProps.content.postType,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.postType) = $event),
                class: "ml-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: "ADMINISTRATORS",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: "MANAGE",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "角色权限",
            prop: "role"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_form_item, {
                    label: "角色",
                    prop: "role"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: slotProps.content.roleId,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.content.roleId) = $event),
                        placeholder: "请选择角色",
                        size: "large",
                        disabled: _unref(state).mode === 'edit' || _unref(state).mode === 'open' ? true : false
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shopAndRoleList), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                    ]),
                    _: 2
                  }, 1024),
                  (slotProps.content.postType === 'MANAGE')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "所属区域",
                        prop: "region"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: slotProps.content.saleModel,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.content.saleModel) = $event),
                            size: "large",
                            style: {"width":"80px"},
                            placeholder: "全部",
                            disabled: _unref(state).mode === 'edit' || _unref(state).mode === 'open' ? true : false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([{
                      value: '',
                      label: '全部',
                    }].concat(_unref(proxy).pocket('saleModel')), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
                          _createVNode(_component_el_select, {
                            modelValue: slotProps.content.region,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.content.region) = $event),
                            placeholder: "全部大区",
                            size: "large",
                            style: {"width":"150px"},
                            disabled: _unref(state).mode === 'edit' || _unref(state).mode === 'open' ? true : false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bigRegionList), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
                          _createVNode(_component_el_select, {
                            modelValue: slotProps.content.village,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.content.village) = $event),
                            placeholder: "全部小区",
                            size: "large",
                            style: {"width":"150px"},
                            disabled: _unref(state).mode === 'edit' || _unref(state).mode === 'open' ? true : false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(villageList), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
                          _createVNode(_component_el_select, {
                            modelValue: slotProps.content.shop,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.content.shop) = $event),
                            placeholder: "全部门店",
                            size: "large",
                            style: {"width":"350px"},
                            disabled: _unref(state).mode === 'edit' || _unref(state).mode === 'open' ? true : false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shopList), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "账号状态",
            prop: "disabled"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: slotProps.content.disabled,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.disabled) = $event),
                placeholder: "请选择账号状态",
                size: "large",
                disabled: _unref(state).mode === 'edit' || _unref(state).mode === 'open' ? true : false
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).storeStateList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["form", "ruleForm", "disabled", "defaultFormFooter"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})